import { Container, Spinner } from "react-bootstrap";
import "../../custom.css";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getPlaceholderByType } from "../../helpers/getPlaceHolderByType";
import Footer from "../../components/Footer";
import Navbar from "../../components/Navbar";

export default function PreviewPage() {
  const { type } = useParams();
  const navigate = useNavigate();

  const fileUrl = sessionStorage.getItem("fileUrl");
  const uniqId = sessionStorage.getItem("uniqId");
  const key = sessionStorage.getItem("key");

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // safety net
    if (!fileUrl || !uniqId) {
      navigate(`/${type}`);
    }
  }, [fileUrl, uniqId, navigate, type]);

  return (
    <>
    <Navbar />
      <Container className="py-5">
        <div id="preview-page">
          <div className="preview-wrapper">
            <div className="preview-card">
              <div className="preview-header">
                <h5>Document</h5>
                <p>
                  {getPlaceholderByType(type)}: {key}
                </p>
              </div>

              <div className="preview-content position-relative">
                {isLoading && (
                  <div className="iframe-loader">
                    <Spinner animation="border" variant="primary" />
                  </div>
                )}

                <iframe
                  src={fileUrl}
                  title="PDF Preview"
                  onLoad={() => setIsLoading(false)}
                />
              </div>
              <small style={{fontStyle:"italic", color: "#ff0000"}}>Note: Apabila terdapat ketidaksesuaian pada data atau dokumen, silakan menghubungi admin.</small>
            </div>
          </div>
        </div>
      </Container>
      <Footer />
    </>
  );
}
